module.exports = __webpack_public_path__ + "static/img/dd.332866b.png";


//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/ly-dashboard/src/dd.png
// module id = FXLM
// module chunks = 1